module.exports = __webpack_public_path__ + "static/media/poker-icon.f25121f2.png";